import store from "../../../../../../store/index";
import questionImg from "../../../../../../img/question-img.svg";


const oneActionToast = {
    warning: (message: string, buttonLabel?: string) =>
    store.dispatch({ type: "OPEN_TOAST", data: { text: message, icon: questionImg, buttonLabel } })
}

export default oneActionToast;